export default __webpack_public_path__ + "static/media/flag-button-active@2x.7ef7a626.png";